export default defineAppConfig({
  toaster: {
    position: "top-right" as const,
    expand: true,
    duration: 5000,
  },
  ui: {
    colors: {
      primary: "orange",
      secondary: "zinc",
      error: "red",
    },

    // ui-pro
    header: {
      slots: {
        right: "gap-3",
      },
    },
    dashboardSidebar: {
      slots: {
        body: "p-2!",
      },
    },
    pageHeader: {
      slots: {
        root: "border-none p-0",
        wrapper: "items-center",
        title: "text-2xl sm:text-2xl font-bold leading-8",
        description: "text-base font-normal leading-6 text-muted",
      },
    },
    // ui-pro

    toast: {
      slots: {
        title: "text-sm font-semibold leading-5",
        description: "text-sm leading-5",
      },
      variants: {
        color: {
          primary: {
            root: "ring-red-200 bg-primary-50",
            title: "text-primary-500",
            description: "text-primary-500",
            icon: "text-primary-500",
            close: "text-primary-500",
          },
          error: {
            root: "ring-red-200 bg-red-50",
            title: "text-red-600",
            description: "text-red-600",
            icon: "text-red-600",
            close: "text-red-600",
          },
          neutral: {
            root: "ring-slate-200 bg-base-white",
            title: "text-slate-950",
            description: "text-slate-950",
            icon: "text-slate-950",
            close: "text-slate-950",
          },
        },
      },
    },
    button: {
      slots: {
        base: "cursor-pointer font-normal justify-center shadow-[0px_1px_2px_-1px_#0000001A] shadow-[0px_1px_3px_0px_#0000001A]",
      },
      variants: {
        size: {
          xss: {
            base: "p-2 rounded-md gap-1 text-xs leading-0 font-medium", // 28px height
            leadingIcon: "size-2",
            leadingAvatarSize: "3xs",
            trailingIcon: "size-2",
          },
          xs: {
            base: "p-1 px-2 rounded-md gap-1 text-sm leading-6 font-medium", // 28px height
            leadingIcon: "size-4",
            leadingAvatarSize: "3xs",
            trailingIcon: "size-4",
          },
          sm: {
            base: "p-1.5 px-2 rounded-md gap-1 text-sm leading-6 font-medium", // 32px height (keep same)
            leadingIcon: "size-4",
            leadingAvatarSize: "3xs",
            trailingIcon: "size-4",
          },
          md: {
            base: "p-2 px-3 rounded-md gap-1 text-sm leading-6 font-medium", // 36px height
            leadingIcon: "size-4",
            leadingAvatarSize: "2xs",
            trailingIcon: "size-4",
          },
        },
        variant: {
          ghost: "shadow-none!",
          link: "shadow-none!",
        },
      },

      compoundVariants: [
        {
          color: "primary",
          variant: "solid",
          class:
            "text-(--color-base-white) bg-(--color-primary-500) hover:bg-(--color-primary-400) focus:text-(--color-base-white) focus:bg-(--color-primary-500)  active:text-(--color-base-white) active:bg-(--color-primary-500) disabled:opacity-30 disabled:text-(--color-base-white)",
        },
        {
          color: "primary",
          variant: "outline",
          class:
            "ring ring-inset ring-(--color-primary-300) text-(--color-primary-500) bg-(--color-base-white) hover:bg-(--color-primary-100) hover:ring-(--color-primary-300) hover:text-(--color-primary-500) focus:ring-(--color-primary-500) focus:text-(--color-primary-500) active:bg-(--color-primary-100) active:text-(--color-primary-500) active:ring-(--color-primary-500) disabled:opacity-50 ",
        },
        {
          color: "secondary",
          variant: "solid",
          class:
            "text-(--color-base-white) bg-(--color-secondary-800) hover:bg-(--color-secondary-600) focus:text-(--color-base-white) focus:bg-(--color-secondary-800)  active:text-(--color-base-white) active:bg-(--color-secondary-600) disabled:opacity-30 disabled:text-(--color-base-white)",
        },

        {
          color: "secondary",
          variant: "outline",
          class:
            "ring ring-inset ring-(--color-secondary-200) text-(--color-slate-950) bg-(--color-base-white) hover:bg-(--color-secondary-50) hover:ring-(--color-secondary-200) hover:text-(--color-slate-950) focus:ring-(--color-secondary-500) focus:text-(--color-slate-950) active:bg-(--color-secondary-50) active:text-(--color-slate-950) active:ring-(--color-secondary-200) disabled:opacity-50",
        },
        {
          color: "primary",
          variant: "ghost",
          class:
            "text-(--color-primary-500) bg-transparent hover:bg-(--color-primary-100) focus:bg-transparent focus:text-(--color-primary-500) active:text-(--color-primary-500) active:bg-(--color-primary-100) disabled:opacity-50",
        },
        {
          color: "secondary",
          variant: "ghost",
          class:
            "text-(--color-slate-950) bg-transparent hover:bg-(--color-secondary-50) focus:bg-transparent focus:text-(--color-slate-950) active:text-(--color-slate-950) active:bg-(--color-secondary-50) disabled:opacity-50",
        },
        {
          color: "primary",
          variant: "link",
          class:
            "text-(--color-primary-500) bg-transparent hover:underline hover:text-(--color-primary-500) focus:bg-transparent focus:text-(--color-primary-500) active:text-(--color-primary-500) active:bg-(--color-primary-100) disabled:opacity-50",
        },
        {
          color: "secondary",
          variant: "link",
          class:
            "text-(--color-slate-950) bg-transparent hover:underline hover:text-(--color-slate-950) focus:bg-transparent focus:text-(--color-slate-950) active:text-(--color-slate-950) active:bg-(--color-secondary-50) disabled:opacity-50",
        },
      ],
    },
    input: {
      slots: {
        base: ["w-full", "disabled:bg-slate-200"],
      },
      variants: {
        size: {
          sm: {
            base: "px-2 py-3! gap-1.5 text-sm font-normal leading-5", // 32px height (keep same)
            leading: "ps-2",
            trailing: "pe-2",
            leadingIcon: "size-4",
            leadingAvatarSize: "3xs",
            trailingIcon: "size-4",
          },
          md: {
            base: "px-3 py-2.5! gap-1.5 text-sm font-normal leading-5", // 36px height
            leading: "ps-3",
            trailing: "pe-3",
            leadingIcon: "size-4",
            leadingAvatarSize: "2xs",
            trailingIcon: "size-4",
          },
          lg: {
            base: "px-4 py-4! gap-2 text-lg font-normal leading-5", // 36px height
            leading: "ps-3",
            trailing: "pe-3",
            leadingIcon: "size-4",
            leadingAvatarSize: "2xs",
            trailingIcon: "size-4",
          },
        },

        variant: {
          outline: "text-highlighted bg-default ring ring-inset ring-slate-200",
        },
      },
      compoundVariants: [
        {
          color: "primary",
          variant: ["outline", "subtle"],
          class:
            "focus-visible:ring-accented/50 focus-visible:shadow-[0px_0px_0px_2px_var(--color-primary-500)] focus-visible:shadow-[0px_0px_0px_2px_var(--color-base-white)",
        },
      ],

      defaultVariants: {
        size: "md",
        color: "primary",
        variant: "outline",
      },
    },

    inputTags: {
      slots: {
        base: ["w-full", "data-disabled:bg-slate-200/75 data-disabled:ring-0"],
        item: [
          "px-1.5 py-0.5 rounded-full font-medium inline-flex items-center gap-0.5",
          'ring ring-inset ring-slate-200 bg-white text-default data-disabled:cursor-not-allowed data-disabled:opacity-75 wrap-anywhere data-[state="active"]:bg-accented',
        ],
        itemText: "text-xs font-semibold leading-4 text-primary-500",
        itemDelete: [
          "inline-flex items-center rounded-xs text-dimmed hover:text-default hover:bg-accented/75 disabled:pointer-events-none",
          "transition-colors",
        ],
      },

      variants: {
        size: {
          sm: {
            base: "px-2 py-3! gap-1.5 text-sm font-normal leading-5", // 32px height (keep same)
            leading: "ps-2",
            trailing: "pe-2",
            leadingIcon: "size-4",
            leadingAvatarSize: "3xs",
            trailingIcon: "size-4",
          },
          md: {
            base: "px-3 py-2.5! gap-1.5 text-sm font-normal leading-5", // 36px height
            leading: "ps-3",
            trailing: "pe-3",
            leadingIcon: "size-4",
            leadingAvatarSize: "2xs",
            trailingIcon: "size-4",
          },
        },

        variant: {
          outline: "text-highlighted bg-default ring ring-inset ring-slate-200",
        },
      },

      compoundVariants: [
        {
          color: "primary",
          variant: ["outline", "subtle"],
          class:
            "has-focus-visible:ring-accented/50 has-focus-visible:shadow-[0px_0px_0px_2px_var(--color-primary-500)] has-focus-visible:shadow-[0px_0px_0px_2px_var(--color-base-white)",
        },
        {
          color: "primary",
          highlight: true,
          class: "ring ring-inset ring-error-500",
        },
      ],

      defaultVariants: {
        size: "md",
        color: "primary",
        variant: "outline",
      },
    },

    textarea: {
      slots: {
        base: ["w-full", "disabled:bg-slate-200"],
      },
      variants: {
        size: {
          sm: {
            base: "px-2 py-2! gap-1.5 text-sm font-normal leading-5", // 32px height (keep same)
            leading: "inset-y-2.5 ps-2",
            trailing: "inset-y-2.5 pe-2",
            leadingIcon: "size-4",
            leadingAvatarSize: "3xs",
            trailingIcon: "size-4",
          },
          md: {
            base: "px-3 py-2.5! gap-1.5 text-sm font-normal leading-5", // 36px height
            leading: "inset-y-3 ps-3",
            trailing: "inset-y-3 pe-3",
            leadingIcon: "size-4",
            leadingAvatarSize: "2xs",
            trailingIcon: "size-4",
          },
          lg: {
            base: "px-4 py-4! gap-2 text-sm sm:text-lg font-normal leading-5", // 36px height
            leading: "inset-y-3 ps-3",
            trailing: "inset-y-3 pe-3",
            leadingIcon: "size-4",
            leadingAvatarSize: "2xs",
            trailingIcon: "size-4",
          },
        },

        variant: {
          outline: "text-highlighted bg-default ring ring-inset ring-slate-200",
        },
      },
      compoundVariants: [
        {
          color: "primary",
          variant: ["outline", "subtle"],
          class:
            "focus-visible:ring-accented/50 focus-visible:shadow-[0px_0px_0px_2px_var(--color-primary-500)] focus-visible:shadow-[0px_0px_0px_2px_var(--color-base-white)",
        },
      ],
      defaultVariants: {
        size: "md",
        color: "primary",
        variant: "outline",
      },
    },

    select: {
      slots: {
        base: [
          "w-full",
          "disabled:bg-slate-200",
          "data-[disabled]:bg-slate-200",
          "disabled:text-dimmed",
        ],
        trailingIcon:
          "group-data-[state=open]:rotate-180 transition-transform duration-200",
        itemTrailing:
          "ms-0 order-first inline-flex size-4 items-center justify-center rounded border border-slate-200 bg-white group-data-[state=checked]:border-primary-500 group-data-[state=checked]:bg-primary-500",
        itemTrailingIcon: "size-3 text-white",
      },
      variants: {
        size: {
          sm: {
            base: "px-2 py-3! gap-1.5 text-sm font-normal leading-5", // 32px height (keep same)
            leading: "ps-2",
            trailing: "pe-2",
            leadingIcon: "size-4",
            leadingAvatarSize: "3xs",
            trailingIcon: "size-4",

            label: "p-1.5 text-sm gap-1.5",
            item: "p-1.5 text-sm gap-1.5",
            itemLeadingIcon: "size-4",
            itemLeadingAvatarSize: "3xs",
            itemLeadingChip: "size-4",
            itemLeadingChipSize: "sm",
            itemTrailingIcon: "size-4",
          },
          md: {
            base: "px-3 py-2.5! gap-1.5 text-sm font-normal leading-5", // 36px height
            leading: "ps-3",
            trailing: "pe-3",
            leadingIcon: "size-4",
            leadingAvatarSize: "2xs",
            trailingIcon: "size-4",

            label: "p-1.5 text-sm gap-1.5",
            item: "p-1.5 text-sm gap-1.5",
            itemLeadingIcon: "size-4",
            itemLeadingAvatarSize: "2xs",
            itemLeadingChip: "size-4",
            itemLeadingChipSize: "md",
            itemTrailingIcon: "size-4",
          },
        },

        variant: {
          outline: "text-highlighted bg-default ring ring-inset ring-slate-200",
        },
      },

      compoundVariants: [
        {
          color: "primary",
          variant: ["outline", "subtle"],
          class:
            "data-[state=open]:ring-accented/50 data-[state=open]:shadow-[0px_0px_0px_2px_var(--color-primary-500)] data-[state=open]:shadow-[0px_0px_0px_2px_var(--color-base-white) focus:ring-accented/50 focus:shadow-[0px_0px_0px_2px_var(--color-primary-500)] focus:shadow-[0px_0px_0px_2px_var(--color-base-white)",
        },
      ],
      defaultVariants: {
        size: "md",
        color: "primary",
        variant: "outline",
      },
    },

    selectMenu: {
      slots: {
        base: ["w-full", "disabled:bg-slate-200!"],
        trailingIcon:
          "group-data-[state=open]:rotate-180 transition-transform duration-200",
        itemDescription: "hidden",
      },

      variants: {
        size: {
          sm: {
            base: "px-2 py-3! gap-1.5 text-sm font-normal leading-5", // 32px height (keep same)
            leading: "ps-2",
            trailing: "pe-2",
            leadingIcon: "size-4",
            leadingAvatarSize: "3xs",
            trailingIcon: "size-4",

            label: "p-1.5 text-sm gap-1.5",
            item: "p-1.5 text-sm gap-1.5",
            itemLeadingIcon: "size-4",
            itemLeadingAvatarSize: "3xs",
            itemLeadingChip: "size-4",
            itemLeadingChipSize: "sm",
            itemTrailingIcon: "size-4",
          },
          md: {
            base: "px-3 py-2.5! gap-1.5 text-sm font-normal leading-5", // 36px height
            leading: "ps-3",
            trailing: "pe-3",
            leadingIcon: "size-4",
            leadingAvatarSize: "2xs",
            trailingIcon: "size-4",

            label: "p-1.5 text-sm gap-1.5",
            item: "p-1.5 text-sm gap-1.5",
            itemLeadingIcon: "size-4",
            itemLeadingAvatarSize: "2xs",
            itemLeadingChip: "size-4",
            itemLeadingChipSize: "md",
            itemTrailingIcon: "size-4",
          },
        },

        variant: {
          outline: "text-highlighted bg-default ring ring-inset ring-slate-200",
        },
      },

      defaultVariants: {
        size: "md",
        color: "primary",
        variant: "outline",
      },
    },

    switch: {
      slots: {
        root: "items-center",
      },
      variants: {
        size: {
          sm: {
            base: "w-9",
            container: "h-5",
            thumb:
              "size-4 data-[state=checked]:translate-x-4 data-[state=checked]:rtl:-translate-x-4",
            wrapper: "text-xs",
          },
          md: {
            base: "w-11",
            container: "h-6",
            thumb:
              "size-5 data-[state=checked]:translate-x-5 data-[state=checked]:rtl:-translate-x-5",
            wrapper: "text-sm",
          },
        },
      },
    },

    formField: {
      slots: {
        root: "w-full [&>*>*]:w-full group",
        labelWrapper: "gap-1 justify-start",
        label: "group-has-[.has-error]:text-error",
        error: "has-error",
      },
    },
    tabs: {
      variants: {
        size: {
          md: {
            trigger: "px-3 py-1.5 gap-1.5 text-sm leading-5",
            leadingIcon: "size-4",
            leadingAvatarSize: "2xs",
          },
        },
      },
      compoundVariants: [
        {
          orientation: "horizontal",
          variant: "link",
          class: {
            list: "border-b -mb-px",
            indicator: "-bottom-px h-[2px]",
          },
        },
        {
          color: "secondary",
          variant: "pill",
          class: {
            indicator: "bg-white",
            trigger:
              "data-[state=active]:text-black focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-inverted shadow-[0px_1px_2px_0px_var(--color-base-white)/.05]",
          },
        },
        {
          color: "secondary",
          variant: "link",
          class: {
            indicator: "bg-slate-900",
            trigger:
              "data-[state=active]:text-slate-900 focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary",
          },
        },
      ],
      defaultVariants: {
        color: "secondary",
        variant: "pill",
        size: "md",
      },
    },
    badge: {
      slots: {
        base: "leading-4 font-semibold",
      },
      variants: {
        md: {
          base: "text-xs px-2.5 py-0.5 gap-1 rounded-md",
          leadingIcon: "size-4",
          leadingAvatarSize: "3xs",
          trailingIcon: "size-4",
        },
      },
      compoundVariants: [
        {
          color: "primary",
          variant: "solid",
          class: "bg-primary-500 text-slate-50",
        },
        {
          color: "primary",
          variant: "outline",
          class: "text-primary ring ring-inset ring-slate-200",
        },
        {
          color: "secondary",
          variant: "solid",
          class: "bg-slate-100 text-slate-900",
        },
        {
          color: "secondary",
          variant: "outline",
          class: "text-slate-900 ring ring-inset ring-slate-200",
        },
      ],
      defaultVariants: {
        color: "primary",
        variant: "solid",
        size: "md",
      },
    },
    avatar: {
      slots: {
        root: "bg-zinc-100 text-zinc-500",
        icon: "text-zinc-500",
      },
      variants: {
        size: {
          "2xs": {
            root: "size-4 text-[8px]",
          },
          xs: {
            root: "size-6 text-xs",
          },
          sm: {
            root: "size-8 text-sm",
          },
          md: {
            root: "size-10 text-base",
          },
          lg: {
            root: "size-12 text-lg",
          },
          xl: {
            root: "size-14 text-xl",
          },
          "2xl": {
            root: "size-16 text-2xl",
          },
        },
      },
    },
    card: {
      slots: {
        root: "divide-none",
        header: "p-6! pb-0!",
        body: "p-6!",
        footer: "p-6! pt-0!",
      },
    },
    modal: {
      slots: {
        overlay: "modal-overlay",
        content: "divide-none",
        title: "text-slate-950 text-lg font-semibold leading-none",
        description: "text-slate-500 text-sm font-normal leading-5",
        close: "top-2 end-2",
        header: "p-6!",
        body: "p-6! pt-0!",
        footer: "p-6! pt-0!",
      },
    },

    calendar: {
      slots: {
        header:
          "gap-0.5 [&>button]:shadow-[0px_1px_2px_-1px_#0000001A]! [&>button]:shadow-[0px_1px_3px_0px_#0000001A]!",
        cellTrigger: [
          "m-0 my-0.5 p-1.5 rounded-none text-(--color-slate-950) data-[disabled]:opacity-[.3]",
          "data-[highlighted]:bg-(--color-slate-100)! data-[selected]:bg-(--color-slate-100)! data-[selected]:text-(--color-slate-950)!",
          `data-[selection-start='true']:rounded-md data-[selection-start='true']:bg-(--color-primary-500)! data-[selection-start='true']:text-(--color-slate-50)!`,
          `data-[selection-end='true']:rounded-md data-[selection-end='true']:bg-(--color-primary-500)! data-[selection-end='true']:text-(--color-slate-50)!`,
          "data-today:ring data-today:ring-inset data-today:rounded-md data-today:ring-primary-500",
        ],
      },
    },
    alert: {
      slots: {
        root: "px-8 py-4",
        title: "text-sm font-semibold leading-5 line-clamp-1",
        description: "line-clamp-1",
      },
      defaultVariants: {
        variant: "subtle",
      },
    },
    navigationMenu: {
      slots: {
        label: "text-xs leading-5 font-medium text-slate-700/70 px-2 py-1.5",
        link: "text-sm leading-5 font-normal",
        separator: "h-0",
      },
      variants: {
        active: {
          true: {
            // childLink: "before:bg-error-500",
            link: "text-slate-700! before:bg-slate-200!",
            linkLeadingIcon: "text-slate-700!",
          },
          false: {
            link: "text-slate-700",
            linkLeadingIcon: "text-slate-700",
          },
        },
      },
    },
    radioGroup: {
      slots: {
        indicator: [
          "relative h-4 w-4 rounded-full border-2 border-slate-300 !bg-white",
          "data-[state=checked]:!bg-white group-data-[state=checked]:!bg-white",
          "data-[state=checked]:border-[#F37B2E] group-data-[state=checked]:border-[#F37B2E]",
          `after:content-[''] after:absolute after:inset-0 after:m-auto`,
          "after:rounded-full after:bg-[#F37B2E]",
          "after:opacity-0 after:scale-0 after:transition-all after:duration-200",
          "data-[state=checked]:after:opacity-100 data-[state=checked]:after:scale-100",
          "group-data-[state=checked]:after:opacity-100 group-data-[state=checked]:after:scale-100",
          "after:!size-2",
        ],
        item: "has-[button[disabled]]:opacity-50 has-[button[disabled]]:cursor-not-allowed",
        label: "text-slate-950 text-sm font-medium",
      },
      compoundVariants: [
        {
          color: "primary",
          variant: "card",
          class: {
            item: "has-data-[state=checked]:border-muted has-data-[state=checked]:bg-primary-50",
          },
        },
      ],
    },

    tooltip: {
      slots: {
        content: "h-[32px] px-3 py-1.5 text-sm leading-5",
      },
    },

    fileUpload: {
      slots: {
        base: "bg-orange-50 border-0 [background-image:repeating-linear-gradient(0deg,var(--color-slate-500),var(--color-slate-500)_6px,transparent_6px,transparent_12px),repeating-linear-gradient(90deg,var(--color-slate-500),var(--color-slate-500)_6px,transparent_6px,transparent_12px),repeating-linear-gradient(180deg,var(--color-slate-500),var(--color-slate-500)_6px,transparent_6px,transparent_12px),repeating-linear-gradient(270deg,var(--color-slate-500),var(--color-slate-500)_6px,transparent_6px,transparent_12px)] [background-position:0_0,0_0,100%_0,0_100%] [background-size:1px_100%,100%_1px,1px_100%,100%_1px] bg-no-repeat",
        label: "text-base",
        description: "text-sm",
      },
      variants: {
        disabled: {
          true: "bg-slate-100",
        },
        layout: {
          list: {
            root: "gap-2 items-start",
            files: "flex flex-col w-full gap-2 hidden",
            file: "min-w-0 flex items-center border border-default rounded-md w-full",
            fileTrailingButton: "ms-auto",
          },
          grid: {
            fileWrapper: "hidden",
            fileLeadingAvatar: "size-full rounded-lg",
            fileTrailingButton:
              "absolute -top-1.5 -end-1.5 p-0 rounded-full border-2 border-bg",
          },
        },
      },
    },
    slideover: {
      slots: {
        content: "w-full md:w-4/5 lg:w-4/6 max-w-none!",
        overlay: "bg-(--color-zinc-800)/75",
      },
    },
  },
});
